import { useMutation } from "react-query";
import { fetchApi } from "helpers/reactQueryApi";
import { includes } from "lodash";

export default function useLinkCrawler(options) {
  return useMutation(async (url: string) => {
    const payload = await fetchApi("/system/crawls", {
      method: "POST",
      body: { url, status: "initialized" },
    });
    const id = payload.id;
    if (payload?.status === "finished") {
      return payload;
    }

    if (!id) {
      throw new Error("Failed to initialize the crawl.");
    }

    async function crawlLink() {
      let keepPolling = true;

      while (keepPolling) {
        const payload = await fetchApi(`/system/crawls/${id}`, {
          method: "GET",
        });

        if (payload?.status === "finished") {
          keepPolling = false;
          return payload;
        }

        if (payload?.status === "error") {
          keepPolling = false;
          throw new Error("Crawl failed with error status");
        }

        if (!includes(["initialized", "retry"], payload?.status)) {
          keepPolling = false;
          throw new Error("Unexpected crawl status.");
        }

        await new Promise((resolve) => setTimeout(resolve, 5000));
      }
    }

    await new Promise((resolve) => setTimeout(resolve, 2500));

    return crawlLink();
  }, options);
}
